import CartNav from './CartNav';

export default CartNav;


// WEBPACK FOOTER //
// ./src/components/CartNav/index.tsx